<template>
    <v-form ref="form" v-model="valid" :disabled="disabled">
        <v-row>
            <!-- TODO [P4] workaround -->
            <v-text-field v-show="false" />
            <v-col v-if="!isProductFieldDisabled('PICK_UP_TIME')" cols="5" sm="3" md="3" lg="3" xl="2">
                <time-field
                    v-if="!offer.time.length"
                    v-model="time"
                    :label="productFieldLabel('transfers.pickup_time', 'PICK_UP_TIME')"
                    :rules="timeRules"
                    :min="offer.departureTimeFrom"
                    :max="offer.departureTimeTo"
                    validate-on-blur
                />
                <v-select
                    v-else
                    v-model="time"
                    :items="offer.time"
                    :rules="timeRules"
                    :label="productFieldLabel('transfers.pickup_time', 'PICK_UP_TIME')"
                    bg-color="white"
                    prepend-icon="mdi-clock"
                />
            </v-col>
            <v-col v-if="!hidePickupSine && !isProductFieldDisabled('PICK_UP_SIGN')" cols="7" sm="9" md="6" xl="5">
                <v-text-field
                    v-model="pickupSign"
                    :rules="pickupSignRules"
                    :label="productFieldLabel('transfers.pickup_sign', 'PICK_UP_SIGN')"
                />
            </v-col>
        </v-row>
        <div
            v-if="groupTransfer && !offer.time.length && !isProductFieldDisabled('PICK_UP_TIME')"
            class="text-caption font-italic font-weight-medium"
        >
            {{ $t('transfers.pickup_time_notification') }}
        </div>
    </v-form>
</template>

<script lang="ts">
    import {Component, mixins, Prop, VModel} from 'vue-facing-decorator'
    import TimeField from '@/components/snippets/forms/TimeField.vue'
    import {TransferFormMixin} from '@/components/transfers/mixins/TransferFormMixin.vue'
    import {ProductBookingFieldsMixin} from '@/components/booking/mixins/ProductBookingFieldsMixin.vue'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'

    @Component({
        components: {TimeField},
    })
    export class TransferDetailsForm extends mixins(
        TransferFormMixin,
        ProductBookingFieldsMixin,
        FormValidationRulesMixin
    ) {
        @VModel({default: false}) valid
        @Prop({required: true}) offer
        @Prop({default: false, type: Boolean}) disabled
        @Prop({default: false, type: Boolean}) hidePickupSine

        mounted() {
            if (this.offer.time.length === 1) {
                this.time = this.offer.time[0]
            }
            if (this.$conf.public.booking.transferPickupSign && !this.pickupSign) {
                this.pickupSign = this.$conf.public.booking.transferPickupSign
            }
        }

        getProp(prop) {
            return this.request[prop]
        }

        setProp(prop, val) {
            this.change({prop, val})
        }

        get pickupSignRules() {
            const rules = []
            if (this.isProductFieldMandatory('PICK_UP_SIGN') && !this.disableRequiredRule) {
                rules.push(this.requiredRule('transfers.pickup_sign', 'PICK_UP_SIGN'))
            }
            return rules
        }

        get time() {
            return this.getProp('time')
        }

        set time(val) {
            this.setProp('time', val)
        }

        get pickupSign() {
            return this.getProp('pickupSign')
        }

        set pickupSign(val) {
            this.setProp('pickupSign', val)
        }

        get groupTransfer() {
            return this.offer.transferType === 'GROUP'
        }

        get timeRules() {
            const rules = []

            if (this.time && this.offer.departureTimeFrom && this.offer.departureTimeTo) {
                const hours = this.time.split(':')[0]
                const minutes = this.time.split(':')[1]
                const departureHoursTo = this.offer.departureTimeTo.split(':')[0]
                const departureMinutesTo = this.offer.departureTimeTo.split(':')[1]
                const departureHoursFrom = this.offer.departureTimeFrom.split(':')[0]
                const departureMinutesFrom = this.offer.departureTimeFrom.split(':')[1]

                if (hours === departureHoursTo && minutes > departureMinutesTo)
                    rules.push(this.$t('pick-up_time_after', {prop: this.offer.departureTimeTo}))
                if (hours === departureHoursFrom && minutes < departureMinutesFrom)
                    rules.push(this.$t('pick-up_time_before', {prop: this.offer.departureTimeFrom}))
            }

            if (this.isProductFieldMandatory('PICK_UP_TIME') && !this.disableRequiredRule) {
                rules.push(this.requiredRule('transfers.pickup_time', 'PICK_UP_TIME'))
            }

            return rules
        }
    }

    export default TransferDetailsForm
</script>
